<template>
	<div>
		<div>武林秘籍：九阴主板</div>
		<!-- <SentimentMarketHotTrend  zoom_start="0"></SentimentMarketHotTrend> -->
		<QuantJyJyPool quant_code="9016" title="九阴主板" zoom_start="45"></QuantJyJyPool>
	</div>
</template>

<script>
	import QuantJyJyPool from 'components/quant/QuantJyJyPool.vue'
	// import SentimentMarketHotTrend from 'components/sentiment/SentimentMarketHotTrend.vue'
	export default {
		data() {
			return {
			}
		},
		components: {
			QuantJyJyPool,
			// SentimentMarketHotTrend
		},
		methods: {

		}
	}
</script>

<style>
</style>
